import {
  getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

type Options = {
  onSuccess?: () => void;
  onError?: (error: AxiosError<{ errors?: string[] }>) => void;
};

/**
 * 初回ログイン未完了者への再招待メール一斉送信フック（任意発火）
 *
 * 送信対象は利用者一覧と同じ絞り込み（未ログインユーザー + keyword 検索）となるよう、
 * `keyword` を送信することで検索結果に対してのみ一括送信する。
 *
 * @param threeLetterCode - クライアントコード
 * @param keyword - 送信対象を絞り込む検索キーワード（未指定の場合は絞り込まない）
 * @param options - コールバックオプション
 */
export const usePostClientUsersBulkLoginReminder = (
  threeLetterCode: string,
  keyword?: string,
  options?: Options
) => {
  const params = { keyword: keyword || undefined };

  return useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationKey(
      threeLetterCode,
      params
    ),
    getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationFetcher(
      threeLetterCode,
      params
    ),
    options
  );
};
